<button *ngFor="let tech of allTechnologies"
        mat-icon-button
        (click)="toggleTechnology(tech)"
>
  <mat-icon *ngIf="technologyToIncludedInFilter[tech]"
            class="white"
            [svgIcon]="technologyToFilterIcon[tech][technologyToIncludedInFilter[tech]]"
            matTooltipPosition="below"
            [matTooltip]="technologyToTooltip[tech].tooltipForActive"
  ></mat-icon>
  <mat-icon *ngIf="!technologyToIncludedInFilter[tech]"
            class="grey"
            [svgIcon]="technologyToFilterIcon[tech][technologyToIncludedInFilter[tech]]"
            matTooltipPosition="below"
            [matTooltip]="technologyToTooltip[tech].tooltipForInactive"
  ></mat-icon>
</button>
<mat-icon class="tooltip-icon" svgIcon="tooltip"
          matTooltip="Shows only those projects that contain the selected technologies of Onshore Wind, Solar and/or Storage"
></mat-icon>
